import React, { useCallback, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import ReactCanvasConfetti from "react-canvas-confetti";

const canvasStyles = {
  position: "fixed",
  pointerEvents: "none",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
};
const Confirmation = () => {
  const refAnimationInstance = useRef(null);

  const getInstance = useCallback((instance) => {
    refAnimationInstance.current = instance;
  }, []);

  const makeShot = useCallback((particleRatio, opts) => {
    refAnimationInstance.current &&
      refAnimationInstance.current({
        ...opts,
        origin: { y: 0.5, x: 0.5 },
        particleCount: Math.floor(200 * particleRatio),
        colors: ["#bd67e2", "#67e2bd", "#e267ca", "#ffff00"],
      });
  }, []);

  const fire = useCallback(() => {
    makeShot(0.25, {
      spread: 26,
      startVelocity: 55,
    });

    makeShot(0.2, {
      spread: 60,
    });

    makeShot(0.35, {
      spread: 100,
      decay: 0.91,
      scalar: 0.5,
    });

    makeShot(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 0.8,
    });

    makeShot(0.1, {
      spread: 120,
      startVelocity: 45,
    });
  }, [makeShot]);

  useEffect(() => {
    fire();
  }, []);

  return (
    <div className="wrapper">
      <ReactCanvasConfetti refConfetti={getInstance} style={canvasStyles} />
      <div className="confirmation">
        <h1 className="confirmation__title">RSVP sent! 🎉</h1>
        <p className="confirmation__message">
          Thanks! There&#39;s nothing left to do! But, if you want you can return back to the main
          page by clicking <Link to="/">here</Link>
        </p>
      </div>
    </div>
  );
};

export default Confirmation;
export { Confirmation };
